var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("confirmDlg", { ref: "confirm" }),
      _c("messageDlg", { ref: "message" }),
      _c("loaderDlg", { ref: "loader" }),
      _vm.signedIn
        ? _c("RwNavigationDrawer", {
            scopedSlots: _vm._u(
              [
                {
                  key: "menu-content",
                  fn: function() {
                    return [_c("Menu")]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3356103596
            ),
            model: {
              value: _vm.drawerMenu,
              callback: function($$v) {
                _vm.drawerMenu = $$v
              },
              expression: "drawerMenu"
            }
          })
        : _vm._e(),
      _vm.signedIn
        ? _c("RwHeader", {
            scopedSlots: _vm._u(
              [
                {
                  key: "bar-nav-icon",
                  fn: function() {
                    return [
                      _c("v-app-bar-nav-icon", {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.drawerMenu = !_vm.drawerMenu
                          }
                        }
                      }),
                      _c("img", { attrs: { src: _vm.logoFilename } }),
                      _c("v-spacer"),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.signout()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-export")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3026371101
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("global.disconnect")))
                          ])
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1933374827
            )
          })
        : _vm._e(),
      _c("v-main", [_c("router-view")], 1),
      _c("RwFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }